import { jsx } from "react/jsx-runtime";
import { createContextScope } from "@tamagui/create-context";
import { SELECT_NAME } from "./constants";
const [createSelectContext, createSelectScope] = createContextScope(SELECT_NAME);
const [SelectProvider, useSelectContext] = createSelectContext(SELECT_NAME);
const ForwardSelectContext = (props) => {
  return /* @__PURE__ */ jsx(SelectProvider, { isInSheet: true, scope: props.__scopeSelect, ...props.context, children: props.children });
};
export {
  ForwardSelectContext,
  SelectProvider,
  createSelectContext,
  createSelectScope,
  useSelectContext
};
//# sourceMappingURL=context.js.map
